import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiInfo, FiCheckCircle } from 'react-icons/fi';

export default function Hero() {
  return (
    <section className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 bg-slate-900 overflow-hidden min-h-[80vh] flex items-center">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&q=80&w=2000" 
          alt="Exhibition Hall" 
          className="w-full h-full object-cover opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900 via-slate-900/80 to-transparent"></div>
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="max-w-3xl">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <span className="inline-block py-1 px-3 rounded-full bg-amber-500/20 text-amber-500 border border-amber-500/30 text-sm font-medium mb-6 tracking-widest">
              專業 設計。製造廠。出租佈展
            </span>
            
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6 text-shadow">
              展示櫃。展示板。<br/>
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-amber-200">
                標示牌。活動展覽牆
              </span>
            </h2>
            
            <p className="text-lg md:text-xl text-slate-300 mb-10 max-w-2xl leading-relaxed">
              為您的展覽、賣場、學校、醫院提供最專業的空間展示解決方案。從設計到進撤場安裝，我們提供全方位的優質服務。
            </p>

            {/* Important Notice Box */}
            <div className="glass-panel rounded-xl p-6 md:p-8 bg-slate-800/60 border-slate-700 max-w-2xl">
              <div className="flex items-start gap-4">
                <SafeIcon icon={FiInfo} className="text-amber-500 text-3xl shrink-0 mt-1" />
                <div>
                  <h3 className="text-white font-medium text-lg mb-2">展覽租借相關事宜</h3>
                  <p className="text-slate-300 text-sm leading-relaxed">
                    請以 E-mail、Line、Fax 告知以下資訊，我們滿速為您服務，謝謝您！
                  </p>
                  <ul className="mt-4 grid grid-cols-2 gap-2 text-sm text-slate-400">
                    {['型號與數量', '進撤場安裝時間', '詳細地址', '聯絡人及電話'].map((item, i) => (
                      <li key={i} className="flex items-center gap-2">
                        <SafeIcon icon={FiCheckCircle} className="text-amber-500/70" />
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}